import * as React from "react";
import * as HomePage from ".";
import { Helmet, HelmetProvider } from "react-helmet-async";

interface HomePageMainComponentProps {}

export const HomePageMainComponent: React.FunctionComponent<
  HomePageMainComponentProps
> = (props) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="main-section mx-w-1440">
        <HelmetProvider>
          <Helmet>
            <title>
              AR-VR Made Easy, Affordable and Accessible | TechXR
            </title>
            <meta
              name="title"
              content="AR-VR Made Easy, Affordable and Accessible | TechXR"
            />
            <meta
              name="description"
              content="We are on a mission to democratize access to emerging technologies, like Augmented, Virtual and Mixed Reality, with affordable products like the SenseXR controller and our AR-VR apps.
              "
            />
            <meta
              name="keywords"
              content="AR VR, augmented reality, virtual reality, mixed reality, SenseXR controller, AR VR products India, AR VR apps, affordable AR VR, TechXR"
            />
            <meta
              property="image"
              content="https://ddappcdn.techxr.co/techxrWeb/courses/img-web.png"
            />
            <link rel="canonical" href="https://techxr.co/ " />
          </Helmet>
        </HelmetProvider>
        <HomePage.AboveFoldMainComp></HomePage.AboveFoldMainComp>

        <HomePage.UsecaseComp></HomePage.UsecaseComp>

        <HomePage.OurAppsHomeComp></HomePage.OurAppsHomeComp>

        <HomePage.WhyUsMainComp></HomePage.WhyUsMainComp>

        <HomePage.StudentProjectsMainComp></HomePage.StudentProjectsMainComp>

        <HomePage.TestimoniesMainComp></HomePage.TestimoniesMainComp>

        <HomePage.OurPartnersAndAchievementsMainComp></HomePage.OurPartnersAndAchievementsMainComp>

        <HomePage.NewsAndInfo></HomePage.NewsAndInfo>

        <HomePage.EventsMainComp id={""}></HomePage.EventsMainComp>

        {/* <Demo/> */}
      </div>
    </>
  );
};
